<template>
  <nav
    class="flex items-center px-2 py-2 bg-white border-b border-solid select-none border-neutral-300 h-14 2xs:px-4"
  >
    <div class="flex flex-wrap items-center justify-between w-full mx-auto">
      <!-- Logo and home link -->
      <a
        href="https://provstitoender.dk/"
        class="flex items-center h-10 p-2 bg-transparent rounded-lg hover:bg-neutral-100"
      >
        <Home class="w-6 h-6 2xs:hidden text-neutral-800" />
        <span
          class="self-center hidden px-1 text-xl font-semibold leading-none text-center 2xs:inline-block whitespace-nowrap text-neutral-800"
        >
          TØNDER PROVSTI
        </span>
      </a>
      <div class="block w-auto">
        <ul
          class="flex rounded-lg bg-transparent font-medium space-x-1.5 flex-row h-full items-center"
        >
          <!-- Registration and login buttons for non-logged-in users -->
          <li v-if="!isLoggedIn" class="flex items-center h-full">
            <button
              @click="handleRegisterClick"
              :class="{
                'text-white bg-neutral-800': currentView === 'registration',
                'text-neutral-800 bg-neutral-100 hover:bg-neutral-200':
                  currentView !== 'registration',
              }"
              :disabled="currentView === 'registration'"
              class="font-medium rounded-lg text-sm px-3.5 py-2.5 w-28 text-center inline-flex items-center justify-center mr-1"
              type="button"
            >
              <UserPlus :size="18"
            :stroke-width="1.75"
            class="mr-2" />
              Registrer
            </button>
            <button
              @click="handleLoginClick"
              :class="{
                'text-white bg-neutral-800': currentView === 'login',
                'text-neutral-800 bg-neutral-100 hover:bg-neutral-200':
                  currentView !== 'login',
              }"
              :disabled="currentView === 'login'"
              class="font-medium rounded-lg text-sm px-3.5 py-2.5 w-28 text-center inline-flex items-center justify-center"
              type="button"
            >
              <LogIn :size="18"
            :stroke-width="1.75"
            class="mr-2" />
              Log ind
            </button>
          </li>
          <!-- User selector for admin users -->
          <li v-if="isLoggedIn && authStore.isAdmin" class="flex items-center h-full">
            <UserSelector @select-user="handleUserSelect" />
          </li>
          <!-- User dropdown for logged-in users -->
          <li v-if="isLoggedIn" class="flex items-center h-full">
            <UserDropdown :user="user" />
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import UserDropdown from "@/components/ui/UserDropdown.vue";
import UserSelector from "@/components/ui/UserSelector.vue";
import { Home, LogIn, UserPlus } from "lucide-vue-next";
import { useAuthStore } from "@/stores/authStore";

// Initialize auth store
const authStore = useAuthStore();

// Define props
defineProps({
  isLoggedIn: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  currentView: {
    type: String,
    required: true,
  },
});

// Define emits
const emit = defineEmits(["show-registration", "show-login", "select-user"]);

// Method to handle login button click
const handleLoginClick = () => {
  emit("show-login");
};

// Method to handle register button click
const handleRegisterClick = () => {
  emit("show-registration");
};

// Method to handle user selection
const handleUserSelect = (selectedUser) => {
  emit("select-user", selectedUser);
};
</script>